interface UserIconProps {
  className?: string;
}

const UserIconLg: React.FC<UserIconProps> = (props) => {
  return (
    <>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
        <path
          className="stroke-current"
          d="M12.25 41.361a29.212 29.212 0 0 1 31.5-.003"
          strokeWidth="2"
        />
        <rect
          x="20.25"
          y="13.25"
          width="15.5"
          height="15.5"
          rx="7.75"
          className="stroke-current"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};

export default UserIconLg;
